



































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import { User } from "@/types";
import PageHeader from "@/components/PageHeader.vue";
import CommissionView from "@/components/Agents/CommissionView.vue";
import moment from "moment";
import LeadPanel from "@/components/Lead/LeadPanel.vue";
import { getUserId } from "@/helpers";
import logger from "../configs/logger";
import { Routes } from "@/router/routes";
import { getCommissions } from "@/lib/api";

@Component({ components: { PageHeader, CommissionView, LeadPanel } })
export default class Commissions extends Vue {
  @Action("getLead") getLead!: Function;
  @State("user") user!: User;
  @State("inCallMode") inCallMode!: boolean;

  activeLeadId: string = "";
  totalCommissions = 0;
  loading = false;
  dialog = false;
  commissions = [];
  filter: { [key: string]: any } = {
    q: "",
    sale_date: [
      moment()
        .startOf("week")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    ],
    limit: 10,
    key: ""
  };
  nextKey = "";
  prevKey = "";
  limitOptions = [10, 20, 40];
  headers = [
    { text: "First Name", value: "first_name" },
    { text: "Last Name", value: "last_name" },
    { text: "Phone Number", value: "phone_number" },
    { text: "Product", value: "product_name" },
    { text: "Product Type", value: "product_type" },
    { text: "Premium", value: "product_premium" },
    { text: "Commission", value: "commission" },
    { text: "Enrollment Commission", value: "enrollment_fee_commission" },
    { text: "Sale Date", value: "sale_date" },
    { text: "View Lead", value: "firestore_alternate_id" }
  ];

  @Watch("inCallMode")
  onCallModeChange(val: any, preVal: any) {
    if (val) this.dialog = false;
  }

  @Watch("filter", { deep: true })
  onFilterChange(filter: any) {
    this.loadCommissions();
  }

  get filterSaleDateText() {
    return this.filter.sale_date.join(" ~ ");
  }
  get getMaxDate() {
    return moment().format("YYYY-MM-DD");
  }

  mounted() {
    this.loadCommissions();
  }

  handlePreviousPage() {
    this.loadCommissions(this.prevKey);
  }

  handleNextPage() {
    this.loadCommissions(this.nextKey);
  }

  onChangeLimit(val: string) {
    this.filter.limit = val;
  }

  renderDateFormat(date: string) {
    return moment(date).format("YYYY-MM-DD");
  }

  openLookup() {
    this.$router.push({ name: Routes.LookupLead });
  }

  cleanObject(obj: { [key: string]: any }) {
    const cleanObject = obj;
    for (var propName in cleanObject) {
      if (
        cleanObject[propName] === null ||
        cleanObject[propName] === undefined ||
        cleanObject[propName] === ""
      ) {
        delete cleanObject[propName];
      }
    }
    return cleanObject;
  }

  async handleViewLead(leadId: string) {
    logger("log", "this key", leadId);
    this.activeLeadId = leadId;
    this.dialog = true;
  }

  async loadCommissions(key?: String) {
    try {
      this.loading = true;
      const start_date = this.filter.sale_date[0]
        ? moment.utc(this.filter.sale_date[0]).format("YYYY-MM-DDTHH:mm:ss")
        : "";

      const end_date = this.filter.sale_date[1]
        ? moment.utc(this.filter.sale_date[1]).format("YYYY-MM-DDTHH:mm:ss")
        : "";

      const query: { [key: string]: any } = {
        limit: this.filter.limit,
        start_date,
        end_date,
        q: this.filter.q
      };

      if (key) {
        query.key = key;
      }

      const { data } = await getCommissions(this.cleanObject(query));
      this.nextKey = data.next_page_key;
      this.prevKey = data.previous_page_key;
      this.commissions = data.data;
      this.loading = false;
      logger("info", "commissions data", data);
    } catch (err) {
      // @ts-ignore
      if (err.response.data.error) {
        this.loading = false;
        this.$toasted.error(err.response.data.error).goAway(2000);
      } else {
        this.loading = false;
        this.$toasted.error("Lead lookup error").goAway(2000);
      }
    }
  }
}
